// generated from 204 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const deviceCarrierFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("device_carrier_filter"),
  comparison_key: z.enum([
    "10", // 52 (25.49%)
    "1", // 48 (23.53%)
    "25", // 31 (15.20%)
    "27", // 23 (11.27%)
    "11", // 23 (11.27%)
    "28", // 13 (6.37%)
    "2", // 11 (5.39%)
    "26", // 2 (0.98%)
    "12", // 1 (0.49%)
  ]),
  display_name: z.string(),
  // undefined: 61 (29.90%), defined 143 (70.10%)
  raw_value: z
    .union([
      // string samples: 133 (93.01%)
      z.string(),
      // array samples: 10 (6.99%)
      z.array(z.string()),
    ])
    .optional(),
  value: z.union([
    // string samples: 135 (66.18%)
    z.string(),
    // array samples: 69 (33.82%)
    z.array(z.string()),
  ]),
  varies_by_app_group: z.literal(false),
});
